var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar-bottom',{attrs:{"visible":_vm.isVisible,"feeds":_vm.feeds,"routeName":_vm.routeName},on:{"scrolling":_vm.resetTimeout}}),_c('navbar-go-to-top',{attrs:{"visible":_vm.isVisible}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }